const mutations = {
  mutationProvinces(state, data) {
    state.provinces = data;
  },
};

export default mutations;
